import React from "react";
import {Link} from "react-router-dom";
import Image from 'antd/lib/image';
import {useSelector} from "react-redux";
import {formatCompanyLogoUrl} from "../../api/companyApi";


export const Brand = ({ route, maxHeight=80, url, borderRadius=0}) => {
    const companyId = useSelector(state => state.user.data?.company_details?.cid);
    let brandImageUrl = url || formatCompanyLogoUrl(companyId);
    const containerContent = (
        <div className="brand-container" style={{ textAlign: 'center' }}>
                <Image
                  src={brandImageUrl}
                  alt="Brand"
                  preview={false} // Disable click-to-preview functionality
                  style={{ maxWidth: '100%', maxHeight: maxHeight, borderRadius }} // Adjust size as needed
                />
        </div>
    )
    return (
        route ? <Link to={route}>{containerContent}</Link> : containerContent
    );
};
